import { AppEventState } from "@/models/AppEventState";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";

export const getDefaultState = (): AppEventState => {
  return {
    id: 0,
    title: { en: "", ar: "" },
    code: "",
    startDate: "0000-00-00",
    endDate: "0000-00-00",
    domains: []
  };
};

const state: AppEventState = getDefaultState();

export default {
  state,
  getters,
  mutations,
  actions
};
